// Publish approved tasks here. Players can run them but cannot modify definitions.
export const publishedTasks = []

export function validateTask(task) {
  if (!task || typeof task.id !== 'string' || !task.id || typeof task.name !== 'string') throw new Error('任务资料不完整')
  if (!Array.isArray(task.points) || task.points.length < 1 || task.points.length > 100) throw new Error('任务点位数量不正确')
  const points = task.points.map(point => {
    const { x, y } = point || {}
    const delay = point.delay == null ? 500 : Number(point.delay)
    if (![x, y].every(value => typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 1)) throw new Error('任务缺少有效的相对点位')
    if (!Number.isInteger(delay) || delay < 100 || delay > 3600000) throw new Error('点位间隔需为 100 至 3600000 毫秒')
    return { x, y, delay, ...(point.space === 'game-document' ? { space: point.space } : {}) }
  })
  return { id: task.id, name: task.name.slice(0, 40), description: String(task.description || '').slice(0, 160), points }
}

// Speed's pixel coordinates require their saved viewport. Never guess a missing viewport.
export function readSavedPlans(storage) {
  const tasks = [], unavailable = []
  for (const key of ['autoClickPlanList', 'etuw_clicker_plans_v1']) {
    let rows
    try { rows = JSON.parse(storage.getItem(key) || '[]') } catch (_) { unavailable.push('已保存方案数据损坏'); continue }
    if (!Array.isArray(rows)) continue
    rows.slice(0, 100).forEach((row, index) => {
      try {
        const list = row.points || row.pointList
        if (!Array.isArray(list)) throw new Error('缺少点位')
        const points = list.map(point => {
          const width = point.vw || row.viewportWidth, height = point.vh || row.viewportHeight
          if (!(Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0)) throw new Error('旧方案未记录屏幕尺寸，需补齐后适配')
          return { x: (point.x == null ? point.pointX : point.x) / width, y: (point.y == null ? point.pointY : point.y) / height, delay: Number(point.delay || point.timeInterval || row.interval || 1000) }
        })
        tasks.push(validateTask({ id: `${key}:${index}`, name: row.name || '已保存方案', points, description: '已保存点位方案' }))
      } catch (error) { unavailable.push(`${String(row && row.name || '旧方案').slice(0, 40)}：${error.message}`) }
    })
  }
  return { tasks, unavailable }
}
